import { useRef } from "react";
import { accessTokenAtom } from "@utils/auth/auth-atoms";
import { authService } from "@utils/auth/auth-service";
import { AppStore } from "@utils/jotai";

export function useLlmFetch(): typeof fetch {
  const fetchRef = useRef<typeof fetch>(async (input, init) => {
    await authService.refreshAccessTokenIfExpired();
    const token = AppStore.get(accessTokenAtom);
    const headers = new Headers(init?.headers);
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return fetch(input, { ...init, headers });
  });
  return fetchRef.current;
}
